import { FormikHelpers } from "formik";
import AreaForm from "./AreaForm";
import { useGetArea } from "./api/getArea";
import { useEditArea } from "./api/editArea";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditArea = ({handleCloseModal, areaId}: EditAreaProps)  => {
  const getAreaQuery = useGetArea({areaId: areaId})
  const editAreaMutation = useEditArea({data: {}, areaId});

  const handleSubmit = async (values: IPostEditArea, { setSubmitting }: FormikHelpers<IPostEditArea>): Promise<void> => {
    try {
      await editAreaMutation.mutateAsync({
        data: values,
        areaId: areaId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    } finally {
	    setSubmitting(false);
    }
  }

  if (getAreaQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getAreaQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση της Περιοχής.</div>
    )
  }

  return (
    <>
      {!getAreaQuery.isLoading && getAreaQuery.data &&
        <AreaForm initialValues={getAreaQuery.data} type="edit" onSubmit={handleSubmit} />
      }
    </>
  )
}

interface EditAreaProps {
  areaId: number;
  handleCloseModal: () => void;
}

export default EditArea;